import {
  bibliographyApi,
  departmentApi,
  fundingRecipientApi,
  guideTypeApi,
  nirTypeApi,
  participationKindApi,
  participationStatusApi,
  publicationFormApi,
  publishingHouseApi,
  specialityApi,
  stateApi,
  statusApi,
  yearApi,
  interactionTypeApi,
  councilNameApi,
  academicDegreeApi,
  periodApi,
  dissertationDegreeApi,
  scientDepartmentApi,
  nirLevelApi,
  contestResultApi,
  cooperationTypeApi,
  organizationApi,
  foreignOrganizationApi,
  inculcationLevelApi,
  countryApi,
  scientistNameApi,
  protectionPlaceApi,
  scienceStepApi,
  highschoolApi,
  educationalPublicationTypeApi,
  contestApi,
  performanceTypeApi,
  eventTypeApi,
  eventFormatApi,
  participantQuantityApi,
  catalogApi,
  whiteListLevelApi,
  positionApi,
  rewardApi,
  employeePositionApi,
  employeeApi,
  dutyApi,
  personTitleApi,
  salaryRateApi,
  activityApi,
  filetypeApi,
  quarterApi,
  editorialBoardRoleApi
} from '@/api'
import { vm } from '@/main'
import { getSortedList } from '@/scripts/sort'
import { dictionaryNames } from '@/scripts/consts'

export default {
  namespaced: true,

  state: {
    [dictionaryNames.Boolean]: {
      list: [
        { id: 1, name: 'Да', value: true },
        { id: 2, name: 'Нет', value: false }
      ]
    },
    [dictionaryNames.NirType]: {
      list: [],
      api: nirTypeApi.getCatalog,
      rusName: 'Вид НИР'
    },
    [dictionaryNames.Year]: {
      list: [],
      api: yearApi.getCatalog,
      rusName: 'Год',
      sort: {
        value: true,
        type: 'number',
        increase: false,
        fieldName: 'year'
      }
    },
    [dictionaryNames.Speciality]: {
      list: [],
      api: specialityApi.getCatalog,
      createApi: specialityApi.create,
      updateApi: specialityApi.update,
      removeApi: specialityApi.remove,
      rusName: 'Специальности'
    },
    [dictionaryNames.Department]: {
      list: [],
      api: departmentApi.getCatalog,
      rusName: 'Кафедры'
    },
    [dictionaryNames.FundingRecipient]: {
      list: [],
      api: fundingRecipientApi.getCatalog,
      rusName: 'Получатели финансирования'
    },
    [dictionaryNames.Bibliography]: {
      list: [],
      api: bibliographyApi.getCatalog,
      rusName: 'Библиографическая БД',
      onlyIsActual: true
    },
    [dictionaryNames.ParticipationStatus]: {
      list: [],
      api: participationStatusApi.getCatalog,
      rusName: 'Роль в организации'
    },
    [dictionaryNames.ParticipationKind]: {
      list: [],
      api: participationKindApi.getCatalog,
      rusName: 'Вид исполнения'
    },
    [dictionaryNames.GuideType]: {
      list: [],
      api: guideTypeApi.getCatalog,
      rusName: 'Показатель'
    },
    [dictionaryNames.PublicationForm]: {
      list: [],
      api: publicationFormApi.getCatalog,
      rusName: 'Форма издания'
    },
    [dictionaryNames.PublishingHouse]: {
      list: [],
      api: publishingHouseApi.getCatalog,
      createApi: publishingHouseApi.create,
      updateApi: publishingHouseApi.update,
      removeApi: publishingHouseApi.remove,
      rusName: 'Издательство'
    },
    [dictionaryNames.State]: {
      list: [],
      api: stateApi.getCatalog,
      rusName: 'Место издательства'
    },
    [dictionaryNames.InteractionType]: {
      list: [],
      api: interactionTypeApi.getCatalog,
      rusName: 'Тип сотрудничества'
    },
    [dictionaryNames.CouncilName]: {
      list: [],
      api: councilNameApi.getCatalog,
      rusName: 'Наименование диссертационного совета'
    },
    [dictionaryNames.AcademicDegree]: {
      list: [],
      api: academicDegreeApi.getCatalog,
      rusName: 'Учёная степень'
    },
    [dictionaryNames.Period]: {
      list: [],
      api: periodApi.getCatalog,
      rusName: 'Период',
      sort: {
        value: true,
        type: 'number',
        increase: false,
        fieldName: 'id'
      }
    },
    [dictionaryNames.InculcationLevel]: {
      list: [],
      api: inculcationLevelApi.getCatalog,
      rusName: 'Уровень внедрения'
    },
    [dictionaryNames.DissertationDegree]: {
      list: [],
      api: dissertationDegreeApi.getCatalog,
      rusName: 'Докторская степень'
    },
    [dictionaryNames.Status]: {
      list: [],
      api: statusApi.getCatalog,
      rusName: 'Статус работы'
    },
    [dictionaryNames.ScientDepartment]: {
      list: [],
      api: scientDepartmentApi.getCatalog,
      rusName: 'Подразделения'
    },
    [dictionaryNames.NirLevel]: {
      list: [],
      api: nirLevelApi.getCatalog,
      rusName: 'Уровень НИР'
    },
    [dictionaryNames.ContestResult]: {
      list: [],
      api: contestResultApi.getCatalog,
      rusName: 'Результат'
    },
    [dictionaryNames.CooperationType]: {
      list: [],
      api: cooperationTypeApi.getCatalog,
      rusName: 'Тип сотрудничества'
    },
    [dictionaryNames.Organization]: {
      list: [],
      api: organizationApi.getCatalog,
      createApi: organizationApi.create,
      rusName: 'Организации'
    },
    [dictionaryNames.ForeignOrganization]: {
      list: [],
      api: foreignOrganizationApi.getCatalog,
      createApi: foreignOrganizationApi.create,
      rusName: 'Зарубежная организация'
    },
    [dictionaryNames.Country]: {
      list: [],
      api: countryApi.getCatalog,
      rusName: 'Страна'
    },
    [dictionaryNames.ScientistName]: {
      list: [],
      api: scientistNameApi.getCatalog,
      createApi: scientistNameApi.create,
      rusName: 'ФИО зарубежного ученого'
    },
    [dictionaryNames.ProtectionPlace]: {
      list: [],
      api: protectionPlaceApi.getCatalog,
      createApi: protectionPlaceApi.create,
      updateApi: protectionPlaceApi.update,
      removeApi: protectionPlaceApi.remove,
      rusName: 'Организация'
    },
    [dictionaryNames.ScienceStep]: {
      list: [],
      api: scienceStepApi.getCatalog,
      rusName: 'Научный уровень'
    },
    [dictionaryNames.Highschool]: {
      list: [],
      api: highschoolApi.getCatalog,
      rusName: 'Организация'
    },
    [dictionaryNames.EducationalPublicationType]: {
      list: [],
      api: educationalPublicationTypeApi.getCatalog,
      rusName: 'Тип учебно-методической публикации'
    },
    [dictionaryNames.Contest]: {
      list: [],
      api: contestApi.getCatalog,
      rusName: ''
    },
    [dictionaryNames.PerformanceType]: {
      list: [],
      api: performanceTypeApi.getCatalog,
      rusName: 'Тип выступления'
    },
    [dictionaryNames.EventType]: {
      list: [],
      api: eventTypeApi.getCatalog,
      rusName: 'Статус мероприятия'
    },
    [dictionaryNames.EventFormat]: {
      list: [],
      api: eventFormatApi.getCatalog,
      rusName: 'Формат мероприятия'
    },
    [dictionaryNames.ParticipantQuantity]: {
      list: [],
      api: participantQuantityApi.getCatalog,
      rusName: 'Общее число участников'
    },
    [dictionaryNames.Catalog]: {
      list: [],
      api: catalogApi.getCatalog,
      rusName: 'Категорирование'
    },
    [dictionaryNames.WhiteListLevel]: {
      list: [],
      api: whiteListLevelApi.getCatalog,
      rusName: 'Уровень белого списка'
    },
    [dictionaryNames.Position]: {
      list: [],
      api: positionApi.getCatalog,
      rusName: 'Должность в диссертационном совете'
    },
    [dictionaryNames.EmployeePosition]: {
      list: [],
      api: employeePositionApi.getCatalog,
      rusName: 'Кафедра'
    },
    [dictionaryNames.Employee]: {
      list: [],
      api: employeeApi.getCatalog,
      rusName: 'Сотрудник'
    },
    [dictionaryNames.Duty]: {
      list: [],
      api: dutyApi.getCatalog,
      rusName: 'Вид должностного исполнения'
    },
    [dictionaryNames.PersonTitle]: {
      list: [],
      api: personTitleApi.getCatalog,
      rusName: 'Должность'
    },
    [dictionaryNames.SalaryRate]: {
      list: [],
      api: salaryRateApi.getCatalog,
      rusName: 'Ставка'
    },
    [dictionaryNames.Activity]: {
      list: [],
      api: activityApi.getCatalog,
      rusName: 'Активность'
    },
    [dictionaryNames.Filetype]: {
      list: [],
      api: filetypeApi.getCatalog,
      rusName: 'Тип файла'
    },
    [dictionaryNames.Reward]: {
      list: [],
      api: rewardApi.getCatalog,
      rusName: 'Награда'
    },
    [dictionaryNames.Quarter]: {
      list: [],
      api: quarterApi.getCatalog,
      rusName: 'Квартал'
    },
    [dictionaryNames.EditorialBoardRole]: {
      list: [],
      api: editorialBoardRoleApi.getCatalog,
      rusName: 'Роль в редакционной коллегии'
    }
  },

  getters: {
    nirTypeList: state => state.nirType.list,
    yearList: state => state.year.list,
    specialityList: state => state.speciality.list,
    departmentList: state => state.department.list,
    fundingRecipientList: state => state.fundingRecipient.list,
    bibliographyList: state => state.bibliography.list,
    participationStatusList: state => state.participationStatus.list,
    participationKindList: state => state.participationKind.list,
    guideTypeList: state => state.guideType.list,
    publicationFormList: state => state.publicationForm.list,
    publishingHouseList: state => state.publishingHouse.list,
    stateList: state => state.state.list,
    interactionTypeList: state => state.interactionType.list,
    councilNameList: state => state.councilName.list,
    academicDegreeList: state => state.academicDegree.list,
    periodList: state => state.period.list,
    inculcationLevelList: state => state.inculcationLevel.list,
    dissertationDegreeList: state => state.dissertationDegree.list,
    statusList: state => state.status.list,
    scientDepartmentList: state => state.scientDepartment.list,
    nirLevelList: state => state.nirLevel.list,
    contestResultList: state => state.contestResult.list,
    cooperationTypeList: state => state.cooperationType.list,
    organizationList: state => state.organization.list,
    foreignOrganizationList: state => state.foreignOrganization.list,
    countryList: state => state.country.list,
    scientistNameList: state => state.scientistName.list,
    protectionPlaceList: state => state.protectionPlace.list,
    scienceStepList: state => state.scienceStep.list,
    highschoolList: state => state.highschool.list,
    educationalPublicationTypeList: state => state.educationalPublicationType.list,
    contestList: state => state.contest.list,
    performanceTypeList: state => state.performanceType.list,
    eventTypeList: state => state.eventType.list,
    eventFormatList: state => state.eventFormat.list,
    participantQuantityList: state => state.participantQuantity.list,
    catalogList: state => state.catalog.list,
    whiteListLevelList: state => state.whiteListLevel.list,
    positionList: state => state.position.list,
    employeePositionList: state => state.employeePosition.list,
    employeeList: state => state.employee.list,
    dutyList: state => state.duty.list,
    personTitleList: state => state.personTitle.list,
    salaryRateList: state => state.salaryRate.list,
    activityList: state => state.activity.list,
    filetypeList: state => state.filetype.list,
    rewardList: state => state.reward.list,
    quarterList: state => state.quarter.list,
    booleanList: state => state[dictionaryNames.Boolean].list,
    editorialBoardRoleList: state => state.editorialBoardRole.list
  },

  mutations: {
    setDictionary(state, { dictionaryType, payload }) {
      if (payload && state[dictionaryType]) state[dictionaryType].list = payload
    },

    addInDictionary(state, { dictionaryType, payload }) {
      if (payload && state[dictionaryType]) state[dictionaryType].list.push(payload)
    },

    updateInDictionary(state, { dictionaryType, payload }) {
      if (payload && state[dictionaryType]) {
        const index = state[dictionaryType].list.findIndex(el => el.id === payload.id)
        state[dictionaryType].list.splice(index, 1, payload)
      }
    },

    removeInDictionary(state, { dictionaryType, id }) {
      if (id && state[dictionaryType]) {
        const index = state[dictionaryType].list.findIndex(el => el.id === id)
        state[dictionaryType].list.splice(index, 1)
      }
    },

    clearDictionary(state, dictionaryName) {
      if (dictionaryName && state[dictionaryName]) {
        state[dictionaryName].list = []
      }
    }
  },

  actions: {
    async addInDictionary({ state, commit }, { dictionaryType, payload }) {
      const data = await state[dictionaryType].createApi(payload)
      commit('addInDictionary', {
        dictionaryType,
        payload: data
      })
      return data
    },

    async updateInDictionary({ state, commit }, { dictionaryType, payload }) {
      const data = await state[dictionaryType].updateApi(payload)
      commit('updateInDictionary', {
        dictionaryType,
        payload: data
      })
      return data
    },

    async removeInDictionary({ state, commit }, { dictionaryType, id }) {
      await state[dictionaryType].removeApi(id)
      commit('removeInDictionary', {
        dictionaryType,
        id
      })
    },

    async getDictionaries({ state, commit }, dictionaryTypeList = []) {
      try {
        const apiList = []
        const currentDictionaryTypeList = []

        for (const dictionaryType of dictionaryTypeList) {
          if (state[dictionaryType] && !state[dictionaryType].list.length) {
            apiList.push(state[dictionaryType].api)
            currentDictionaryTypeList.push(dictionaryType)
          }
        }

        const dictionaryList = await Promise.allSettled(apiList.map(api => api()))
        const dictionaryTypeWithErrors = []

        for (let i = 0; i < dictionaryList.length; i++) {
          if (dictionaryList[i].status === 'fulfilled') {
            let dictionary = dictionaryList[i].value
            const sortParam = state[currentDictionaryTypeList[i]].sort
            const onlyIsActual = state[currentDictionaryTypeList[i]].onlyIsActual

            if (sortParam?.value)
              dictionary = getSortedList(dictionary, sortParam?.type, sortParam?.increase, sortParam?.fieldName)

            if (onlyIsActual) dictionary = dictionary.filter(el => el.isActual)

            commit('setDictionary', {
              dictionaryType: currentDictionaryTypeList[i],
              payload: dictionary
            })
          } else {
            if (state?.[currentDictionaryTypeList[i]])
              dictionaryTypeWithErrors.push(state[currentDictionaryTypeList[i]].rusName)
          }
        }
        if (dictionaryTypeWithErrors.length)
          throw new Error(
            `Не удалось получить следующие справочники: ${dictionaryTypeWithErrors.join(
              ', '
            )}. Некоторые функции на странице могут быть недоступны`,
            { cause: 'Custom error' }
          )
      } catch (error) {
        console.log(error)
        vm.showErrorMessage(
          error,
          error.cause === 'Custom error'
            ? error.message
            : 'Не удалось получить все необходимые справочники. Некоторые функции на странице могут быть недоступны.'
        )
      }
    }
  }
}
